module.exports = __webpack_public_path__ + "images/accents/accent-productdiscs-share-deacd0c145ab63183b65e88a2c96fe72.webp";